<template>
  <!-- 验证码倒计时组件，因为放dialog中有问题，所以没有使用 -->
  <div>
    <el-button  v-if="Verification" @click="btnClick">获取验证码</el-button>
    <el-button  v-else-if="!Verification"><span>{{timer}}</span>秒后重新获取</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Verification: true
    }
  },
  methods: {
    btnClick() {
      this.$emit('btn-click')
    }

  }

}
</script>

<style  scoped lang="scss">

</style>
